var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrestCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.59 6L10 8.59 7.41 6 6 7.41 8.59 10 6 12.59 7.41 14 10 11.41 12.59 14 14 12.59 11.41 10 14 7.41zM10 0a10 10 0 1010 10A9.991 9.991 0 0010 0zm0 18a8 8 0 118-8 8.011 8.011 0 01-8 8z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+CiAgICA8cGF0aAogICAgICAgICAgICBkPSJNMTQuNTksOCwxMiwxMC41OSw5LjQxLDgsOCw5LjQxLDEwLjU5LDEyLDgsMTQuNTksOS40MSwxNiwxMiwxMy40MSwxNC41OSwxNiwxNiwxNC41OSwxMy40MSwxMiwxNiw5LjQxWk0xMiwyQTEwLDEwLDAsMSwwLDIyLDEyLDkuOTkxLDkuOTkxLDAsMCwwLDEyLDJabTAsMThhOCw4LDAsMSwxLDgtOEE4LjAxMSw4LjAxMSwwLDAsMSwxMiwyMFoiCiAgICAgICAgICAgIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yIC0yKSIKICAgICAgICAgICAgZmlsbD0iY3VycmVudENvbG9yIgogICAgLz4KPC9zdmc+";
export { SvgCrestCircle as ReactComponent };